import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Users, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { fmtCurrencyFull, scoreColor } from "@/lib/format";

export default function Leads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/leads").then((r) => setLeads(r.data)).finally(() => setLoading(false));
  };

  useEffect(load, []);

  const convert = async (lid) => {
    try {
      const r = await api.post(`/leads/${lid}/convert`);
      toast.success("Lead converted to opportunity");
      window.location.href = `/app/opportunities/${r.data.oid}`;
    } catch {
      toast.error("Failed");
    }
  };

  return (
    <div className="space-y-6">
      <header>
        <div className="text-[10px] uppercase tracking-widest text-emerald-400 mb-2">Seller Funnel</div>
        <h1 className="font-heading text-4xl tracking-tight">Inbound Leads</h1>
        <p className="text-sm text-slate-400 mt-1">{leads.length} sellers · sorted by recency</p>
      </header>

      <div className="ae-card overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-[10px] uppercase tracking-widest text-slate-500 border-b border-white/8">
              <th className="text-left px-4 py-3">Score</th>
              <th className="text-left px-4 py-3">Owner</th>
              <th className="text-left px-4 py-3">Asset</th>
              <th className="text-right px-4 py-3">Asking</th>
              <th className="text-left px-4 py-3">Timeline</th>
              <th className="text-left px-4 py-3">SF Interest</th>
              <th className="text-left px-4 py-3 hidden lg:table-cell">Contact</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={8} className="text-center text-slate-500 py-8">Loading…</td></tr>
            ) : leads.length === 0 ? (
              <tr><td colSpan={8} className="text-center text-slate-500 py-12">
                <Users className="h-8 w-8 mx-auto text-slate-700 mb-2" />
                No leads yet. Share the seller funnel link to start capturing.
              </td></tr>
            ) : leads.map((l) => (
              <tr key={l.lid} className="border-b border-white/5 hover:bg-white/[0.03]" data-testid={`lead-row-${l.lid}`}>
                <td className="px-4 py-3">
                  <div className={`font-mono text-xl font-bold tabular-nums ${scoreColor(l.lead_score)}`}>{l.lead_score}</div>
                </td>
                <td className="px-4 py-3">
                  <div className="font-medium">{l.owner_name}</div>
                  <div className="text-[11px] text-slate-500">{l.source_page || "direct"}</div>
                </td>
                <td className="px-4 py-3 capitalize">{l.asset_type}<div className="text-[11px] text-slate-500">{l.asset_address}</div></td>
                <td className="px-4 py-3 text-right font-mono tabular-nums">{fmtCurrencyFull(l.asking_price)}</td>
                <td className="px-4 py-3 text-xs">{l.timeline || "N/A"}</td>
                <td className="px-4 py-3 text-xs">{l.seller_financing_interest ? <span className="text-emerald-400">Yes</span> : "No"}</td>
                <td className="px-4 py-3 hidden lg:table-cell text-xs text-slate-400">
                  <div>{l.email}</div>
                  <div>{l.phone}</div>
                </td>
                <td className="px-4 py-3">
                  <button
                    onClick={() => convert(l.lid)}
                    data-testid={`convert-lead-${l.lid}`}
                    className="text-xs text-emerald-400 hover:text-emerald-300 inline-flex items-center gap-1"
                  >
                    Convert <ArrowRight className="h-3 w-3" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
